import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { LexileDetailsHistoryDataItem } from 'teacher-ui-client/components/giraffe/charts/lexile-details/history'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface LexileDetailsHistoryResponse {
  lexile_history: {
    student_id: number
    max_lexile: number
    starting_lexile: number
    growth: number
  }[]
}

export async function lexileDetailsHistory(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<LexileDetailsHistoryDataItem[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('lexile_history', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<LexileDetailsHistoryResponse>(url, query)
  if (!data) return null

  const { lexile_history } = data
  if (lexile_history.length === 0) return null

  return lexile_history.map(({ starting_lexile: min, max_lexile: max, growth, student_id }) => {
    const initial = max - growth
    return { student_id, min, max, initial, growth }
  })
}
